module.exports = __webpack_public_path__ + "static/media/grabaseat3_preview.04067e4b.jpg";